module.exports = __webpack_public_path__ + "static/img/service2.0b3a1dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kfc/service2.jpg
// module id = mChP
// module chunks = 0